import React from 'react';
import { func, string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProductPackets } from 'store/actions';

// Import utlilies
import { useUserAgent } from 'components/utilities';

// Import components
import {
	Wrapper,
	Bg,
	GradientBox,
	Box,
	ButtonClose,
	IconCloseStyled,
	GradientRadial,
	Content,
	MobileWrapper
} from './styles';

function PaymentPacketsTemplate({ children, toggle, uuid }) {
	const dispatch = useDispatch();
	const { isMobile } = useUserAgent();
	const { data: packets, loading } = useSelector(
		({ product_packets }) => product_packets
	);

	const handleFetchPackets = async () =>
		await fetchProductPackets(uuid)(dispatch);

	React.useEffect(() => {
		handleFetchPackets();
		// eslint-disable-next-line
	}, []);

	const isPacket = packets.length === 0;

	const handleClose = () => !loading && toggle();

	if (isMobile)
		return (
			<MobileWrapper>
				<ButtonClose onClick={toggle}>
					<IconCloseStyled />
				</ButtonClose>
				{children}
			</MobileWrapper>
		);

	return (
		<Wrapper className="wrapper">
			<Bg onClick={handleClose} />
			<GradientBox className="gradient">
				<Box className="content-box">
					{!loading && (
						<ButtonClose onClick={toggle}>
							<IconCloseStyled />
						</ButtonClose>
					)}
					<GradientRadial isPacket={isPacket} isLoaded={!loading} />
					<Content>{children}</Content>
				</Box>
			</GradientBox>
		</Wrapper>
	);
}

PaymentPacketsTemplate.propTypes = {
	toggle: func.isRequired,
	uuid: string.isRequired
};

export default PaymentPacketsTemplate;
